const userRouter = [
  {
    userId: 54,
    disableRouter: [
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  {
    userId: 1,
    disableRouter: [
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  {
    userId: 55,
    disableRouter: [
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  {
    userId: 56,
    disableRouter: [
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  // {
  //   userId: 57,
  //   disableRouter: ["authorize"]
  // },
  {
    userId: 58,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
    ],
  },
  {
    userId: 59,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
    ],
  },
  {
    userId: 60,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
    ],
  },
  {
    userId: 61,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
    ],
  },
  {
    userId: 62,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "import_supply_price",
      "proprietaryMerchant",
      "proprietaryMerchantList",
      "proprietarySupplyPrice",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "stockList",
      "batchImportStock",
    ],
  },
  {
    userId: 63,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
    ],
  },
  {
    userId: 64,
    disableRouter: [
      "merchant",
      "authorize",
      "supply_price",
      "import_supply_price",
      "proprietaryMerchant",
      "proprietaryMerchantList",
      "proprietarySupplyPrice",
    ],
  },
  {
    userId: 65,
    disableRouter: ["authorize"],
  },
  {
    userId: 15,
    disableRouter: ["authorize"],
  },
  {
    userId: 71,
    disableRouter: [
      "productControl",
      "brand",
      "productList",
      "batchImportProduct",
      "editProduct",
      "newProduct",
      "productRecord",
      "merchant",
      "authorize",
      "supply_price",
      "import_supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  {
    userId: 72,
    disableRouter: [
      "productControl",
      "brand",
      "productList",
      "batchImportProduct",
      "editProduct",
      "newProduct",
      "productRecord",
      "merchant",
      "authorize",
      "supply_price",
      "import_supply_price",
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  {
    userId: 83,
    disableRouter: [
      "purchase",
      "purchaseDetail",
      "stockin",
      "stockinDetail",
      "settlementManage",
      "settlementList",
    ],
  },
  {
    userId: 84,
    disableRouter: [
      "productList",
      "batchImportProduct",
      "editProduct",
      "newProduct",
      "authorize",
    ],
  },
];

export default userRouter;
